import React from 'react';
import InputLabel from '../../_InputLabel';
import { Slot } from './slots';
var InputFieldLabel = function InputFieldLabel(_ref) {
  var children = _ref.children,
    visuallyHidden = _ref.visuallyHidden;
  return /*#__PURE__*/React.createElement(Slot, {
    name: "Label"
  }, function (_ref2) {
    var disabled = _ref2.disabled,
      id = _ref2.id,
      required = _ref2.required;
    return /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: id,
      visuallyHidden: visuallyHidden,
      required: required,
      disabled: disabled
    }, children);
  });
};
InputFieldLabel.displayName = "InputFieldLabel";
export default InputFieldLabel;